import React, { useEffect, useState } from 'react'

function VideoUrlInput ({
  initialUrl = '',
  videoServiceFieldId,
  videoIdFieldId,
  inputId = 'video_url'
}) {
  const [url, setUrl] = useState(initialUrl)

  useEffect(() => {
    // Get references to the hidden fields
    const serviceField = document.getElementById(videoServiceFieldId)
    const idField = document.getElementById(videoIdFieldId)

    if (!serviceField || !idField) {
      console.error('Video service or ID fields not found')
      return
    }

    // Parse the URL when it changes
    if (!url.trim()) {
      serviceField.value = ''
      idField.value = ''
      return
    }

    // YouTube URL patterns
    const youtubeMatch = url.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/
    )
    if (youtubeMatch) {
      serviceField.value = 'youtube'
      idField.value = youtubeMatch[1]
      return
    }

    // Vimeo URL patterns
    const vimeoMatch = url.match(/(?:vimeo\.com\/)(\d+)/)
    if (vimeoMatch) {
      serviceField.value = 'vimeo'
      idField.value = vimeoMatch[1]
      return
    }

    // If no match and URL is not empty, show alert
    if (url.trim()) {
      serviceField.value = ''
      idField.value = ''
    }
  }, [url, videoServiceFieldId, videoIdFieldId])

  return (
    <div>
      <label
        htmlFor={inputId}
        className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1'
      >
        Video URL
      </label>
      <input
        type='url'
        id={inputId}
        value={url}
        onChange={e => setUrl(e.target.value)}
        placeholder='https://www.youtube.com/watch?v=... or https://vimeo.com/...'
        className='block w-full px-3 py-2 rounded-md border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm'
      />
      <p className='mt-1 text-sm text-gray-600 dark:text-gray-400'>
        Enter a YouTube or Vimeo URL to automatically extract the video ID
      </p>
    </div>
  )
}

export default VideoUrlInput
